import { styled } from '@linaria/react';
import { fonts, primitives, semantic, size, space } from '../../theme/tokens';

export const Row = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${space['space-400']};
  padding: ${space['space-400']} 0;
  border-bottom: 1px solid ${semantic.border.subtle};

  &:last-of-type {
    border-bottom: none;
  }
`;

export const LeftContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-400']};
  min-width: 0;
  flex: 1;
`;

export const LeftContentLink = styled.a`
  display: flex;
  align-items: flex-start;
  gap: ${space['space-400']};
  min-width: 0;
  flex: 1;
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  &:hover .booking-summary-title,
  &:focus-visible .booking-summary-title {
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
    border-radius: ${size.radius['radius-sm']};
  }
`;

export const Thumbnail = styled.div`
  width: 64px;
  height: 64px;
  border-radius: ${size.radius['radius-sm']};
  overflow: hidden;
  flex-shrink: 0;
  background: ${semantic.bg.surfaceSubtle};
`;

export const ThumbnailImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ThumbnailPlaceholder = styled.div`
  width: 100%;
  height: 100%;
  background: ${semantic.bg.surfaceSubtle};
`;

export const TextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-050']};
  min-width: 0;
`;

export const Title = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const MetaLine = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  line-height: ${primitives.typography.lineHeight.normal};
`;

export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: ${space['space-050']};
  flex-shrink: 0;
  text-align: right;
`;

export const PriceAmount = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.sm};
  font-weight: ${fonts.weight.semiBold};
  color: ${semantic.text.primary};
  white-space: nowrap;
`;

export const PriceNote = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
  white-space: nowrap;
`;
